import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { PositionModel } from 'app/core/models/noms/position';
import { PositionService } from 'app/core/services';
import { State } from 'app/core/store/states';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { mergeMap } from 'rxjs/operators';

import * as PositionActions from '../../actions/noms/position.actions';
import { BaseModel } from 'app/core/models';


@Injectable()
export class PositionEffects {

    constructor(
        private actions$: Actions,
        private store: Store<State>,
        private positionService: PositionService
    ) { }

    @Effect()
    GetListOptions$: Observable<Action> = this.actions$.pipe(
        ofType<PositionActions.GetListOptions>(PositionActions.GET_LIST_OPTIONS),
        mergeMap((action) => {
            return this.positionService.getListOptions(true).map((positions: BaseModel[]) => {
                return new PositionActions.GetListOptionsSuccess(positions)
            }, _ => of(new PositionActions.GetListOptionsError()))
        })
    )
}
